import { REMOVE_ITEM_ERROR } from '../constants/ActionTypes'
import type GenericAction from './types/genericAction.types'

export type RemoveLineItemErrorAction = GenericAction<typeof REMOVE_ITEM_ERROR, { partNumber: number; error: { message: string } }>

type State = {
    [key: string]: string
}

const removeLineItemError = (state: State = {}, action: RemoveLineItemErrorAction) => {
    switch (action.type) {
        case REMOVE_ITEM_ERROR:
            return { ...state, [action.partNumber.toString()]: action.error.message }

        default:
            if (Object.keys(state).length > 0) {
                return {}
            }
            return state
    }
}

export default removeLineItemError
